import { api } from './index'
import type { IUser, WithCreatorData, FPost, thumbnail } from 'garden-common';

export const findPostById = async (
  id: FPost<string>['_id'],
  populate: 'full' | 'details' | 'basic' | 'preview'
): Promise<FPost<string> & Partial<WithCreatorData>> => {
  if (!id) return;
  return await api
    .get(`/v2/post/${id}/${populate}`, {
      headers: {
        'cache-control': 'public, max-age=3600'
      }
    })
    .then(res => {
      return res.data.post;
    });
};

export const findPostsByOwner = async (options: {
  id: IUser<string>['_id'] | null;
  page: number;
  limit: number;
  sort?: 'new-to-old' | 'old-to-new' | 'seeds-most-to-least' | 'seeds-least-to-most';
}): Promise<(FPost<string> & Partial<WithCreatorData>)[]> => {
  if(!options.id) return;

  return await api
    .get(`/v2/post/owner/${options.id}/${options.page}`, {
      headers: {
        'cache-control': 'public, max-age=3600'
      },
      params: {
        limit: options.limit,
        sort: options.sort
      }
    })
    .then(res => {
      return res.data.posts;
    });
};

export const findPosts = async (
  limit: number,
  skip: number = 0,
  title?: string
): Promise<FPost<string>[]> => {
  return await api
    .get(`/v2/post/list/posts/${limit}/${skip}?${title ? `title=${title}` : ''}`, {
      headers: {
        'cache-control': 'public, max-age=3600'
      }
    })
    .then(res => {
      return res.data.posts;
    });
};

export const filterPosts = async (
  filters: any,
  filterTags: any,
  filterOwner: any,
  userNameSearch: string,
  sort: number,
  limit: number,
  skip: number
): Promise<FPost<string>[]> => {
  return await api
    .post(
      `/v2/post/filter`,
      {
        filters,
        filterTags,
        filterOwner,
        userNameSearch,
        sort,
        limit,
        skip
      },
      {
        headers: {
          'cache-control': 'public, max-age=3600'
        }
      }
    )
    .then(res => {
      return res.data.items;
    });
};

export const deleteDraft = async (id: FPost<string>['_id']): Promise<FPost<string>[]> => {
  return await api
    .delete(`/v2/post/draft/delete/${id}`, {
      headers: {
        'cache-control': 'public, max-age=3600'
      }
    })
    .then(res => {
      return res.data.items;
    });
};

export const deleteMediaByKeys = async (keys: thumbnail[]): Promise<boolean> => {
  return await api
    .patch(
      `/v2/post/media/delete`,
      { keys },
      {
        headers: {
          'cache-control': 'public, max-age=3600'
        }
      }
    )
    .then(res => {
      return res.data.status;
    });
};

export const publish = async (
  id: FPost<string>['_id']
): Promise<FPost<string>[] | { message: string }> => {
  try {
    if (id) {
      const response = await api.patch(`/v2/post/publish/${id}`, {
        headers: {
          'cache-control': 'public, max-age=3600'
        }
      });
      return response.data.items;
    } else {
      throw new Error('No id provided');
    }
  } catch (error) {
    if (error.response && error.response.status === 400) {
      return error.response.data;
    } else {
      console.error('An error occurred:', error.message);
      throw error;
    }
  }
};
export const deletePost = async (id: FPost<string>['_id']): Promise<FPost<string>[]> => {
  return await api
    .delete(`/v2/post/delete/${id}`, {
      headers: {
        'cache-control': 'public, max-age=3600'
      }
    })
    .then(res => {
      return res.data.items;
    });
};

export const appreciate = async (id: FPost<string>['_id']): Promise<FPost<string>> => {
  return await api
    .post(`/v2/post/appreciate/${id}`, {
      headers: {
        'cache-control': 'public, max-age=3600'
      }
    })
    .then(res => {
      return res.data.post;
    });
};
